<template>
  <div class="main-wrapper">
    <layoutheader />

    <indexbanner />


    <indexwork />

    <indexapp />

    <cursor />
    <indexfooter />
    
  </div>
</template>
<script>
export default {
  name: "index",
};
</script>
